import actionType from '../actions/matchCalendar/actionType';

const initialState = {
  matchCalendarList: [],
  total: 0,
  matchCalendarListLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.INIT_MATCH_CALENDAR_LIST:
      return {
        ...state,
        matchCalendarList: action.payload.matchCalendarList,
        total: action.payload.total,
      };
    case actionType.SET_MATCH_CALENDAR_LOADING:
      return {
        ...state,
        matchCalendarListLoading: action.payload.matchCalendarListLoading,
      };
    default:
      return {
        ...state,
      };
  }
};
